export const SHOW_CAMERA_CONTROL_MODAL = 'SHOW_CAMERA_CONTROL_MODAL';
export const POWER = 'POWER';
